import { gql } from "@apollo/client";

export const CONTACT_NOTE_FIELDS = gql`
  fragment CampaignContactNoteFields on CampaignContactNote {
    id
    text
    updatedAt
    updatedBy {
      id
      fullName
    }
  }
`;

export const ACTIVE_CONTACT_FIELDS = gql`
  ${CONTACT_NOTE_FIELDS}
  fragment ActiveContactFields on CampaignContact {
    id
    data
    note {
      ...CampaignContactNoteFields
    }
    tags {
      id
      tag {
        id
        name
        integrationActions {
          id
        }
      }
    }
  }
`;

export const CAMPAIGN_SWITCHER_CONTACT_FIELDS = gql`
  fragment CampaignSwitcherContactFields on CampaignContact {
    id
    campaign {
      id
      name
      description
      startedAt
    }
  }
`;

export const NOT_ACTIVE_CONTACT_FIELDS = gql`
  ${CAMPAIGN_SWITCHER_CONTACT_FIELDS}
  ${CONTACT_NOTE_FIELDS}
  fragment NotActiveContactFields on CampaignContact {
    ...CampaignSwitcherContactFields
    note {
      ...CampaignContactNoteFields
    }
    tags {
      id
      tag {
        id
        name
      }
    }
  }
`;

export const GET_ACTIVE_CAMPAIGN_CONTACT = gql`
  ${ACTIVE_CONTACT_FIELDS}
  query getActiveCampaignContact($input: GetCampaignContactInput!) {
    getCampaignContact(input: $input) {
      ...ActiveContactFields
    }
  }
`;

export const GET_ACTIVE_CAMPAIGN_CONTACT_FOR_TEXTER = gql`
  ${CONTACT_NOTE_FIELDS}
  query getActiveCampaignContactForTexter($input: GetCampaignContactInput!) {
    getCampaignContact(input: $input) {
      id
      texterViewableData
      note {
        ...CampaignContactNoteFields
      }
      tags {
        id
        tag {
          id
          name
          integrationActions {
            id
          }
        }
      }
    }
  }
`;

export const GET_THREAD_CAMPAIGN_CONTACTS = gql`
  ${NOT_ACTIVE_CONTACT_FIELDS}
  query getThreadCampaignContacts($input: GetCampaignContactsInput!) {
    getCampaignContacts(input: $input) {
      ...NotActiveContactFields
    }
  }
`;

export const GET_THREAD_CAMPAIGN_CONTACTS_FOR_SWITCHER = gql`
  ${CAMPAIGN_SWITCHER_CONTACT_FIELDS}
  query getThreadCampaignContactsForSwitcher(
    $input: GetCampaignContactsInput!
  ) {
    getCampaignContacts(input: $input) {
      ...CampaignSwitcherContactFields
    }
  }
`;

export const SET_CONTACT_NOTE = gql`
  ${CONTACT_NOTE_FIELDS}
  mutation setContactNote($input: CreateOrUpdateCampaignContactNoteInput!) {
    createOrUpdateCampaignContactNote(input: $input) {
      ...CampaignContactNoteFields
    }
  }
`;

export const UPDATE_CONTACT_TAGS = gql`
  ${ACTIVE_CONTACT_FIELDS}
  mutation updateCampaignContactTags($input: UpdateCampaignContactTagsInput!) {
    updateCampaignContactTags(input: $input) {
      ...ActiveContactFields
    }
  }
`;
